import React, { Component } from "react";
import { connect } from "react-redux";
import "../../../css/style.css";

import PayByUpi from "./UpiPaymentOptions/PayByUpi";
import PayByGpay from "./UpiPaymentOptions/PayByGpay";
import HttpApiUtil from "../../../ApiUtils/HttpApiUtil";
import { payUpiGPay, SAVING_UPI_INTENT_DATA, SET_CHECKOUT_IS_CANCEL_BUTTON_DISABLED } from "../../../stores/actions/CommonAction";
import { UPI_FLOWS } from "./Android/constant";

import { setSelectUpiOption } from "../../../stores/actions/UpiPaymentModeAction";
import { isAndroid, isIOS, isBrowser } from "react-device-detect";
import AndroidScreen from "./Android";
import WebScreen from "./Web/index";
import $ from 'jquery'
const ObjHttpApiUtil = new HttpApiUtil();
const Response = {
  TRANSACTION_SUCCESS: 1000,
  INTERNAL_ERROR: 1001,
  TRANSACTION_FAILED: 1002,
  TRANSACTION_PENDING: 1003,
  SESSION_EXPIRED: 1004,
  REQUEST_EXPIRED: 1005
};

class Upi extends Component {
   state = {
    intentData: {},
    loader: true,
    intentStaus: "",
    showUpiIntent: false,
    isUpiCollectEnable: false,
    clearVpa: false,
    hideUpiCollectFlow: false,
    loading: true,
    screen: "DEFAULT_SCREEN",
    redirectLink: ""
  };

  constructor(props) {
    super(props);
    this.error = null;
    this.loading = null;
    this.mercantPaymentData = null;
    this.emiInfo = null;
    this.SelectedUpiThirdPartyAppId = null;
    this.onPayNowBtnClick = this.onPayNowBtnClick.bind(this);
    this.upiPayNowSuccessCb = this.upiPayNowSuccessCb.bind(this);
    this.upiPayNowFailureCb = this.upiPayNowFailureCb.bind(this);
    this.upiIntent = this.upiIntent.bind(this);
    this.getUpiIntent = this.getUpiIntent.bind(this);
    this.changeScreen = this.changeScreen.bind(this);
    this.getUpiLink = this.getUpiLink.bind(this);
    this.updateCustomerVpa = this.updateCustomerVpa.bind(this);
    this.updateHideUpiCollectFlow = this.updateHideUpiCollectFlow.bind(this);
    this.ajaxCall = this.ajaxCall.bind(this);
    this.timer=null
  }

  updateCustomerVpa = (clearVpa) => {
    this.setState({
      clearVpa: clearVpa
    })
  }

  updateHideUpiCollectFlow = (hideCollect) => {
    this.setState({
      hideUpiCollectFlow: hideCollect
    })
  }
  
  ajaxCall = () => {
    const changeStatus=(type)=>[
      this.setState({ screen: type })
    ]
      $.ajax({
        type: "POST",
        // url: "/PinePGRedirect/IsSavedCardDeleted",
        url: process.env.REACT_APP_PG_CONTROLLER + "UPI/GetStatusOfTransaction",
        data:{token:this.props.token,CallHost:1},
        dataType: "JSON",
        success: function (data) {
          if (data != null) {
            if (data.ResponseCode == Response.TRANSACTION_SUCCESS) {
              clearInterval(this.timer);
              changeStatus("SUCCESS_PAGE")

            } else if (
              data.ResponseCode === Response.TRANSACTION_FAILED ||
              data.ResponseCode === Response.SESSION_EXPIRED
            ) {
              changeStatus("FAILED_PAYMENT")

              // this.setState({ screen: "FAILED_PAYMENT" });
              clearInterval(this.timer);
            } 
          }
        },
        error: function (x, e) {
          alert(
            "Oops! We’ve experienced a technical difficulty. Please try again later." +
              (x.responseText || "")
          );
        },
        failure: function (response) {
          alert(response.d);
        },
        async: true,
      });
  };

  onPayNowBtnClick = (selectedUPIOption, token) => {
    this.props.payUpiGPay(
      token,
      selectedUPIOption,
      this.upiPayNowSuccessCb,
      this.upiPayNowFailureCb
    );
  };

  getUpiLink = (prefix, link) => {
    if(prefix) {
      return prefix + link?.slice(6, link.length);
    }
    return link;
  };

  getUpiIntent = () => {
    let upiData;
    let upiFlowAvaialble=[];
    if (this?.props?.merchant_payment_data?.payment_mode_data[0]?.payment_mode_id) {
      upiData = this?.props?.merchant_payment_data?.payment_mode_data.filter((item) => {
        return item.payment_mode_id === 10
      })
      upiFlowAvaialble = upiData[0].data.upi_flows;
    }

    this.setState({
      showUpiIntent: upiFlowAvaialble?.includes(UPI_FLOWS.INTENT),
      isUpiCollectEnable: upiFlowAvaialble?.includes(UPI_FLOWS.COLLECT),
      loading: false,
    });
  }

  upiIntent = (isMobile, prefix) => {
    if (this.props.upiIntentData && !this.state?.intentData?.isFailure) {
      if (this.props.upiIntentData.response_message === "SUCCESS" && this.props?.upiIntentData?.deep_link) {
        if (isMobile) {
          this.setState({
            redirectLink: this.getUpiLink(
              prefix,
              this.props?.upiIntentData?.deep_link
            ),
          });
        }
        this.setState({
          intentData: this.props.upiIntentData,
          showUpiIntent: true,
          loading: false,
        });
      }
      else{
        this.setState({loading:false})
      }
      
    } else {
      ObjHttpApiUtil.payUpiIntentGpay(this.props.token, {
        txn_data: {
          SelectedPaymentModeId: 10,
        },
        upi_data: {
          upi_option: "UPI",
          txn_mode: "INTENT",
        },
      })
        .then((response) => {
          this.props.SAVING_UPI_INTENT_DATA(response.data);
          if (response.data.response_message === "SUCCESS") {
            if (isMobile) {
              this.setState({
                redirectLink: this.getUpiLink(
                  prefix,
                  this.props?.upiIntentData?.deep_link
                ),
              });
            }
            this.setState({
              intentData: {...this.props.upiIntentData, isFailure: false},
              showUpiIntent: true,
              loading: false,
            });
          } else {
            this.setState({
              intentData: {isFailure: true},
              loading: false,
            });
          }
        })
        .catch((error) => {
          console.log("Error in UPI", error);
          this.setState({
            intentData: {isFailure: true},
          });
        })
        .finally(() => {
          this.setState({ loading: false });
        });
    }
  };

  componentDidMount() {
    this.getUpiIntent();
  }

  componentWillUnmount(){
    this.setState({
      redirectLink: ""
    })
    if(this.timer){
      clearInterval(this.timer);
    }
  }

  upiPayNowSuccessCb = (response) => {
    this.props.SET_CHECKOUT_IS_CANCEL_BUTTON_DISABLED(true);
    document.getElementById("UPIForm").submit();
    console.log(response);
  };
  upiPayNowFailureCb = (response) => {
    console.log(response);
  };
  changeScreen = (type) => {
    this.setState({ screen: type });
  };
  render() {
    const { error, loading, merchant_payment_data, upiPaymentModeOptionOpted } =
      this.props;
    let upiPaymentModeConfig = null;
    merchant_payment_data.payment_mode_data.map((paymentModeConfigData) => {
      if (paymentModeConfigData.payment_mode_id == 10) {
        return (upiPaymentModeConfig = paymentModeConfigData.data);
      }
    });
    let renderPaymentOptionByUserChoise = !this.props.upiPaymentModeOptionOpted
      .SelectedUpiThirdPartyUpiApp ? (
      <PayByUpi
        upiSuccessCb={this.upiPayNowSuccessCb}
        upiFailureCb={this.upiPayNowFailureCb}
        clearVpa={this.state.clearVpa}
        updateCustomerVpa={this.updateCustomerVpa}
      />
    ) : this.props.upiPaymentModeOptionOpted.SelectedUpiThirdPartyUpiApp ==
      3 ? (
      <PayByGpay
        upiSuccessCb={this.upiPayNowSuccessCb}
        upiFailureCb={this.upiPayNowFailureCb}
      />
    ) : (
      <PayByUpi
        upiSuccessCb={this.upiPayNowSuccessCb}
        upiFailureCb={this.upiPayNowFailureCb}
        clearVpa={this.state.clearVpa}
        updateCustomerVpa={this.updateCustomerVpa}
      />
    );

    const upiView = () => {
      if (isBrowser)
        return (
          <WebScreen
            screen={this.state.screen}
            setScreen={this.changeScreen}
            data={this.state.intentData}
            checkStatus={this.ajaxCall}
            getUpiLink={this.upiIntent}
            clearVpa={this.updateCustomerVpa}
            hideCollectFlow={this.updateHideUpiCollectFlow}
          />
        );
      if (isAndroid || isIOS)
        return (
          <AndroidScreen
            screen={this.state.screen}
            setScreen={this.changeScreen}
            checkStatus={this.ajaxCall}
            data={this.state.intentData}
            getUpiLink={this.upiIntent}
            redirectLink={this.state.redirectLink}
            showUpiCollect={this.state.isUpiCollectEnable}
            clearVpa={this.updateCustomerVpa}
          />
        );
    };

    return (
      <>
        <div
          id="collapseupi"
          className="card-body collapse active show"
          data-parent="#accordion"
        >
          {this.state.showUpiIntent ? (
            <div className="upi-option-container">{upiView()}</div>
          ) : (
            <h2>Enter your UPI Details</h2>
          )}
          { this.state.isUpiCollectEnable && !this.state.hideUpiCollectFlow && <div class="col-12 upibhim">
            <form
              id="UPIForm"
              method="post"
              action={
                process.env.REACT_APP_PG_CONTROLLER + "pinepg/v2/submit/upi?token=" + encodeURIComponent (this?.props?.token)
              }
            >
              <input
                type="hidden"
                value={
                  this.props.merchant_payment_data.txn_data.pine_pg_txn_id
                }
                name="PinePGTransactionID"
                id="PinePGTransactionID"
              />
              <input
                type="hidden"
                value={this.props.token}
                name="token"
                id="toekn"
              />
              {/* <UpiNavOptions upiOptionsConfigured={upiPaymentModeConfig.UPIPaymentOptions} /> */}
              {this?.props?.merchant_payment_data?.merchant_data?.merchant_id != 316777 && renderPaymentOptionByUserChoise}
            </form>
          </div>}
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    merchant_payment_data:
      state.merchantPaymentDataFetchingReducer.merchantPaymentData,
    token: state.merchantPaymentDataFetchingReducer.token,
    error: state.merchantPaymentDataFetchingReducer.error,
    loading: state.merchantPaymentDataFetchingReducer.loading,
    upiPaymentModeOptionOpted: state.selectedUpiThirdPartyAppOptionReducer,
    upiIntentData:state?.merchantPaymentDataFetchingReducer?.upiIntentData||null
  };
};
export default connect(mapStateToProps, { setSelectUpiOption, payUpiGPay, SAVING_UPI_INTENT_DATA, SET_CHECKOUT_IS_CANCEL_BUTTON_DISABLED })(
  Upi
);
